











import { Component, Prop, Vue } from 'vue-property-decorator'

import AppRouterLink from '@/components/AppRouterLink.vue'

@Component({
  components: {
    AppRouterLink
  }
})
export default class extends Vue {
  @Prop(String) readonly url!: string

  get routerLocation () {
    if (this.url) {
      const url = this.url.trim()
      const origin = process.env.VUE_APP_WEB_ORIGIN || ''
      if (url.startsWith(origin)) {
        return url.substring(origin.length)
      }
    }
    return ''
  }
}
